import type { PublicContactInfo } from '../../configuration/application/types';

export type ContactPolicyKind = 'phone' | 'email';

export type ResolvedContactPolicyRow = {
  kind: ContactPolicyKind;
  display: string;
  telHref?: string;
  mailto?: string;
};

/** Map public `/app/configuration`.contact into ContactPanel rows. */
export function resolveContactRowsFromConfig(
  contact: PublicContactInfo,
): ResolvedContactPolicyRow[] {
  const rows: ResolvedContactPolicyRow[] = [];

  if (contact.phone) {
    const digits = contact.phone.replace(/[^\d+]/g, '');
    rows.push({
      kind: 'phone',
      display: contact.phone,
      telHref: digits || undefined,
    });
  }

  if (contact.email) {
    rows.push({
      kind: 'email',
      display: contact.email,
      mailto: contact.email,
    });
  }

  return rows;
}
